<template>

    <v-page-section>
        <template #title>Tracking Domain</template>
        <template #body>
            <v-form-group label="Domain Name" caption="Enter a domain name you’d like to use for link tracking. The subdomain must be click, link, or track.">
                <v-input-group class="w-400" placeholder="link.mydomain.com" :model="params.domain" @input="params.domain = $event" />
            </v-form-group>
            <v-form-group label="CNAME Record" caption="Create a CNAME record in your DNS and point your domain name here.">
                <v-copy-box class="w-400" dark>track.crowdpower.io</v-copy-box>
            </v-form-group>
        </template>
        <template #footer>
            <v-button size="sm" :loading="loading" @click.native="updateTrackingDomain">Save &amp; Verify</v-button>
        </template>
    </v-page-section>

</template>

<script>

import ProjectApi from '@api/ProjectApi';

export default {

    data() {
        return {
            loading: false,
            params: {},
        }
    },

    mounted() {
        this.params = {
            domain: this.project.tracking_domain,
        };
    },

    methods: {

        updateTrackingDomain() {
            this.loading = true;
            ProjectApi.updateTrackingDomain(this.project.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>